import PropTypes from 'prop-types';
import { memo, forwardRef,useEffect } from 'react';
// @mui
import Box from '@mui/material/Box';
//
import { StyledRootScrollbar, StyledScrollbar } from './styles';

// ----------------------------------------------------------------------

const Scrollbar = forwardRef(({ children, sx, ...other }, ref) => {
  const userAgent = typeof navigator === 'undefined' ? 'SSR' : navigator.userAgent;

  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);

  useEffect(() => {
    document.body.style.overflowX = 'hidden'; // Disable horizontal scrolling
    document.body.style.overflowY = 'auto'; // Allow vertical scrolling
    document.documentElement.style.overflowX = 'hidden'; // Disable horizontal scrolling
    document.documentElement.style.overflowY = 'auto'; // Allow vertical scrolling
  
    return () => {
      document.body.style.overflowX = 'auto'; // Reset horizontal overflow on unmount
      document.body.style.overflowY = 'auto'; // Reset vertical overflow on unmount
      document.documentElement.style.overflowX = 'auto'; // Reset horizontal overflow on unmount
      document.documentElement.style.overflowY = 'auto'; // Reset vertical overflow on unmount
    };
  }, []);
  


  if (isMobile) {
    return (
      <Box ref={ref} sx={{ overflow: 'auto', ...sx }} {...other}>
        {children}
      </Box>
    );
  }

  return (
    <StyledRootScrollbar>
      <StyledScrollbar
        scrollableNodeProps={{
          ref,
        }}
        clickOnTrack={false}
        sx={sx}
        {...other}
      >
        {children}
      </StyledScrollbar>
    </StyledRootScrollbar>
  );
});

Scrollbar.propTypes = {
  children: PropTypes.node,
  sx: PropTypes.object,
};

export default memo(Scrollbar);
